export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  date: string;
  imageSeq: string;
  imageUrl: string;
  tags: string[];
  views: number;
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2026世界杯预选赛亚洲区：中国队关键战役前瞻',
    summary: '中国队将在世预赛亚洲区迎来关键一战，面对实力强劲的对手，球队上下已经做好了充分准备。本文将从阵容、战术、历史交锋等多个维度进行全面分析。',
    content: `<p>随着2026年世界杯预选赛亚洲区进入白热化阶段，中国男足即将迎来一场至关重要的比赛。这场比赛不仅关系到球队的出线前景，更承载着亿万中国球迷的期待。</p>
<p>从阵容配置来看，中国队此次集结了国内联赛表现最为出色的球员，同时也有多名在海外效力的球员归队。主教练在赛前发布会上表示，球队已经针对对手的战术特点进行了充分准备。</p>
<p>战术层面，中国队可能会采取相对稳健的防守反击策略。对手在主场作战，控球能力出众，中国队需要在防守端保持高度集中，同时利用快速反击制造威胁。</p>
<p>历史交锋记录显示，两队过往交手多次，中国队虽然在整体战绩上稍处下风，但近年来差距正在逐渐缩小。上一次交锋中，中国队曾展现出令人眼前一亮的表现。</p>
<p>球迷们对于这场比赛充满期待，各大社交平台上关于阵容预测、比分竞猜的讨论热度持续攀升。无论结果如何，中国足球正在一步一个脚印地向前迈进。</p>
<p>让我们共同期待中国队能够在这场关键战役中发挥出最佳水平，为世界杯梦想继续奋斗！</p>`,
    category: 'football',
    author: 'ky体育编辑部',
    date: '2026-08-07',
    imageSeq: 'article-football-wc-qualify',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20football%20match%20action%20photography%20with%20dramatic%20stadium%20lighting%2C%20players%20competing%20on%20green%20pitch%2C%20warm%20golden%20hour%20tones%2C%20atmospheric%20crowd%20background%2C%20clean%20professional%20sports%20photography%2C%20high%20detail%2C%20editorial%20style&width=800&height=480&seq=article-football-wc-qualify&orientation=landscape',
    tags: ['世界杯', '中国队', '世预赛', '足球'],
    views: 12850,
  },
  {
    id: 'a2',
    title: 'NBA新赛季前瞻：五支最值得关注的球队深度分析',
    summary: 'NBA新赛季即将拉开帷幕，各支球队在休赛期进行了大规模调整。本文精选五支最具看点的球队，从阵容变化到战术升级进行全面解读。',
    content: `<p>NBA新赛季的脚步日益临近，各支球队在休赛期的运作已经基本尘埃落定。在这个充满变数的新赛季，哪些球队最值得球迷关注？</p>
<p>首先是卫冕冠军，他们在保留了核心阵容的基础上，通过选秀和自由市场补强了板凳深度。新赛季他们依旧是总冠军的最有力竞争者。</p>
<p>其次是一支在休赛期完成重磅交易的西部劲旅，他们通过交易得到了一位全明星级别的球员，整体实力得到显著提升。新赛季的西部竞争将更加激烈。</p>
<p>东部方面，一支年轻球队在上赛季季后赛中展现出了惊人的潜力，经历了一个赛季的历练后，这群年轻球员有望在新赛季实现更大突破。</p>
<p>另外两支值得关注的球队分别是：一支经历了重建的老牌强队，以及一支通过选秀积累了多名高顺位新秀的新兴力量。这两支球队虽然战绩可能不会太出色，但比赛过程一定会充满看点。</p>
<p>新赛季的NBA，充满了无限可能。让我们拭目以待！</p>`,
    category: 'basketball',
    author: 'ky体育编辑部',
    date: '2026-08-06',
    imageSeq: 'article-nba-preview',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20with%20dramatic%20arena%20lighting%2C%20player%20dunking%20with%20intense%20expression%2C%20warm%20golden%20court%20lights%2C%20atmospheric%20indoor%20stadium%2C%20clean%20professional%20sports%20photography%2C%20high%20contrast%2C%20editorial%20style&width=800&height=480&seq=article-nba-preview&orientation=landscape',
    tags: ['NBA', '篮球', '新赛季', '前瞻'],
    views: 9630,
  },
  {
    id: 'a3',
    title: '英雄联盟S16全球总决赛：LPL赛区竞争力全面解析',
    summary: 'S16全球总决赛即将开战，LPL赛区四支代表队已全部确定。本文将对各队实力、选手状态及赛区整体竞争力进行全面分析。',
    content: `<p>英雄联盟S16全球总决赛即将拉开帷幕，作为全球最具影响力的电竞赛事之一，每年的世界赛都吸引着数以亿计的玩家关注。</p>
<p>LPL赛区本次共有四支队伍晋级全球总决赛，分别是春季赛冠军、夏季赛冠军以及通过冒泡赛杀出重围的两支劲旅。从整体实力来看，今年的LPL赛区依旧保持着极高的竞技水平。</p>
<p>春季赛冠军队伍本赛季展现出了统治级别的实力，无论是个人能力还是团队配合都处于顶尖水准。他们的中野组合被认为是当今世界最强的组合之一。</p>
<p>夏季赛冠军则是一支以团队执行力著称的队伍，他们的比赛节奏把控和资源置换能力堪称教科书级别。在BO5赛制下，这支队伍的实力不容小觑。</p>
<p>冒泡赛突围的两支队伍同样各具特色，一支以激进的打架风格著称，另一支则擅长后期运营。四支队伍风格各异，让LPL赛区在本届世界赛上拥有了更多战术选择。</p>
<p>当然，LCK和LEC赛区的队伍同样实力强劲，全球总决赛的竞争一定会异常激烈。期待LPL赛区能够在S16上再创辉煌！</p>`,
    category: 'esports',
    author: 'ky体育电竞组',
    date: '2026-08-05',
    imageSeq: 'article-lol-s16',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20dramatic%20stage%20lighting%2C%20gaming%20teams%20competing%20on%20stage%2C%20large%20LED%20screens%20displaying%20game%20action%2C%20atmospheric%20crowd%2C%20warm%20red%20and%20gold%20tones%2C%20clean%20professional%20photography%2C%20editorial%20style&width=800&height=480&seq=article-lol-s16&orientation=landscape',
    tags: ['英雄联盟', 'S16', 'LPL', '电竞'],
    views: 15200,
  },
  {
    id: 'a4',
    title: '温网冠军之路：新生代选手如何改写网球历史',
    summary: '温布尔登网球锦标赛见证了新生代选手的崛起，他们用出色的表现向世界证明，网坛新时代已经到来。',
    content: `<p>温布尔登网球锦标赛作为网球运动最具历史底蕴的赛事，一直以来都是网坛风向标。今年的温网赛场上，新生代选手的表现令人印象深刻。</p>
<p>在男单赛场上，22岁的西班牙新星一路过关斩将，先后击败了多位种子选手，最终闯入决赛。他的打法兼具力量与技巧，正手进攻尤其犀利，被认为是未来世界第一的有力竞争者。</p>
<p>女单方面同样不乏惊喜，19岁的美国小将在本届温网上演了黑马奇迹。她以资格赛选手的身份一路打进四强，创造了个人大满贯最佳战绩。</p>
<p>这些新生代选手的崛起，为网坛注入了新鲜血液。他们的技术特点更加全面，身体素质更加出色，比赛风格也更加富有观赏性。</p>
<p>随着费德勒、纳达尔等传奇选手逐渐淡出赛场，网坛新时代的大幕已经拉开。这些年轻选手能否肩负起重任，续写网坛辉煌？让我们拭目以待。</p>`,
    category: 'tennis',
    author: 'ky体育编辑部',
    date: '2026-08-04',
    imageSeq: 'article-tennis-wimbledon',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20on%20grass%20court%20with%20dramatic%20natural%20lighting%2C%20player%20serving%20with%20intense%20focus%2C%20warm%20golden%20afternoon%20sun%2C%20classic%20tennis%20venue%20atmosphere%2C%20clean%20professional%20sports%20photography%2C%20editorial%20style&width=800&height=480&seq=article-tennis-wimbledon&orientation=landscape',
    tags: ['网球', '温网', '新生代', '大满贯'],
    views: 7840,
  },
  {
    id: 'a5',
    title: 'F1 2026赛季半程回顾：黑马频出，争冠格局大变',
    summary: 'F1 2026赛季已经过半，本赛季的竞争格局与往年大不相同。多支车队展现出强劲竞争力，让争冠形势变得扑朔迷离。',
    content: `<p>F1 2026赛季已经完成了12站比赛，本赛季的竞争激烈程度超出了大多数人的预期。与往年红牛一家独大的局面不同，本赛季至少有四支车队具备争夺分站冠军的实力。</p>
<p>技术规则的变化是导致竞争格局改变的主要原因。新赛季引入的空气动力学规则让各支车队回到了相对接近的起跑线，一些传统中游车队抓住了这个机会，实现了跨越式进步。</p>
<p>车手表现方面，卫冕冠军虽然依旧稳定，但面临着来自队友和其他车队车手的强力挑战。本赛季已经有五位不同的车手站上过最高领奖台，这在近年来的F1赛场上是比较少见的。</p>
<p>中国车手周冠宇在本赛季的表现也可圈可点，多次进入积分区，展现了稳定的竞技状态。随着经验的积累，他正在逐步成长为一名更加全面的F1车手。</p>
<p>下半赛季的比赛将更加关键，各支车队的升级节奏和策略选择将对最终排名产生重要影响。本赛季的F1，值得每一位赛车迷持续关注。</p>`,
    category: 'others',
    author: 'ky体育编辑部',
    date: '2026-08-03',
    imageSeq: 'article-f1-midseason',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Formula%201%20racing%20car%20on%20track%20with%20dramatic%20motion%20blur%2C%20high%20speed%20action%20shot%2C%20warm%20golden%20sunset%20lighting%2C%20racing%20circuit%20atmosphere%2C%20clean%20professional%20motorsport%20photography%2C%20editorial%20style&width=800&height=480&seq=article-f1-midseason&orientation=landscape',
    tags: ['F1', '赛车', '赛季回顾', '周冠宇'],
    views: 6210,
  },
  {
    id: 'a6',
    title: '斯诺克世锦赛决赛：奥沙利文冲击第八冠传奇',
    summary: '斯诺克世锦赛决赛即将在克鲁斯堡剧院打响，火箭奥沙利文将向个人第八个世锦赛冠军发起冲击，这将是斯诺克历史上又一个里程碑时刻。',
    content: `<p>斯诺克世锦赛决赛即将在谢菲尔德的克鲁斯堡剧院上演。火箭罗尼·奥沙利文再次站在了距离冠军仅一步之遥的位置上。</p>
<p>如果能够成功夺冠，这将是奥沙利文职业生涯的第八个世锦赛冠军，也将进一步巩固他作为斯诺克历史上最伟大球员的地位。此前他已经超越了亨德利的七个世锦赛冠军纪录。</p>
<p>本赛季奥沙利文的状态依旧出色，尽管已经年近五十，但他的出杆速度和技术水准丝毫没有下降的迹象。在本次世锦赛的晋级之路上，他先后击败了多位实力强劲的对手。</p>
<p>决赛的对手同样不容小觑，这位年轻选手在本赛季表现出色，球风稳健且心理素质过硬。他在半决赛中上演了精彩逆转，展现出了冠军球员应有的气质。</p>
<p>无论决赛结果如何，奥沙利文已经用他的职业生涯为斯诺克运动树立了一座丰碑。而这位传奇球员的故事，还在继续书写。</p>`,
    category: 'others',
    author: 'ky体育编辑部',
    date: '2026-08-02',
    imageSeq: 'article-snooker-wc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20snooker%20match%20with%20dramatic%20table%20lighting%2C%20player%20taking%20a%20shot%20with%20intense%20concentration%2C%20classic%20green%20baize%20table%2C%20warm%20spotlight%20illumination%2C%20atmospheric%20theatre%20venue%2C%20clean%20professional%20sports%20photography%2C%20editorial%20style&width=800&height=480&seq=article-snooker-wc&orientation=landscape',
    tags: ['斯诺克', '奥沙利文', '世锦赛', '传奇'],
    views: 5430,
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((a) => {
  articleMap[a.id] = a;
});

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getHotArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
}